import ApiRequest from "../../api/ApiRequest";

export const CLIENT_ID = '8839b3a138125f41e05542f3c9be2e';
export const CLIENT_SECRET = 'OhegnXr5GDMVsPCrnHArg8ZxR6VAXlrnVtgM81M9';

let refreshTimer = null;

export default class Session {
  static get accessToken() {
    return localStorage.getItem('access_token');
  }

  static set accessToken(value) {
    if (undefined === value) {
      return;
    }

    localStorage.setItem('access_token', value);
  }

  static removeAccessToken() {
    localStorage.removeItem('access_token');
  }

  static get refreshToken() {
    return localStorage.getItem('refresh_token');
  }

  static set refreshToken(value) {
    if (undefined === value) {
      return;
    }

    localStorage.setItem('refresh_token', value);
  }

  static removeRefreshToken() {
    localStorage.removeItem('refresh_token');
  }

  static set tokens(tokensInfo) {
    if (undefined === tokensInfo) {
      return;
    }

    const TOKEN_REFRESH_GAP = 60; // sec. when access token will be expired
    const refreshThrough = (TOKEN_REFRESH_GAP < tokensInfo.expires_in)  ? tokensInfo.expires_in - TOKEN_REFRESH_GAP : tokensInfo.expires_in;

    this.accessToken = tokensInfo.access_token;
    this.refreshToken = tokensInfo.refresh_token;

    refreshTimer = setTimeout(() => this.reloadTokens(), refreshThrough * 1000);
  }

  static removeTokens() {
    clearTimeout(refreshTimer);
    this.removeAccessToken();
    this.removeRefreshToken();
  }

  static async reloadTokens() {
    if (null === this.refreshToken) {
      return;
    }

    const requestedData = {
      grant_type: 'refresh_token',
      refresh_token: this.refreshToken,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      scope: '',
    };

    const response = await ApiRequest.oAuthRefreshToken.postRefresh(requestedData);
    if (!response) return;
    this.tokens = response;
  }
}
